const config = {
	// api_host: "http://localhost:3003",
	api_host: "https://cloud-bread-server.herokuapp.com",
	api_region: "https://www.emsifa.com/api-wilayah-indonesia/api",
};
export default config;
